angular.module("registrationModule").component("registrationMain", {
	templateUrl: "registrationMain/registrationMain.html",
	bindings: {
		onTrackStep: "&",
		onContinueToSignIn: "&",
		onFbLogin: "&",
		onValidateEmail: "&",
		onContinue: "&",
		onClose: "&",
		user: "<",
		errorMessages: "<",
		text: "<",
		altText: "<",
		customTitle: "<",
		altTitle: '<',
		termsOfUseUrl: "<",
		privacyPolicyUrl: "<",
		isSignupOnly: '<',
		isSignUpClicked: "<",
		calloutBoxType: '<',
		calloutBoxSourcePage: '<',
		adDesignVersion: "<",
		adDesignEnabled: "<",
		googleButtonRender: "&"
	},
	controller: ["$document", "$timeout", "$sce", "$element", "patterns", function($document, $timeout, $sce, $element, patterns) {
		var self = this;
		this.titleText = $sce.trustAsHtml(self.text);
		this.$onChanges = function (changes) {
			if (changes.text) {
				self.titleText = $sce.trustAsHtml(changes.text.currentValue);
			}
		};
		this.titleTextAlternative = $sce.trustAsHtml(self.textAlternative);
		this.patterns = patterns;
		this.userEmailHasChanged = false;
		this.showTitleText = true;

		this.googleButtonRender();

		this.fbLogin = function () {
			self.onFbLogin({form: self.form});
		};

		this.emailSignUpOrSignIn = function (emailExists = false) {
			if (emailExists) {
				self.onContinue({ isSignUp: false });
			} else {
				self.onContinue({ isSignUp: true });
			}
		};

		this.emailLogin = function () {
			this.validateEmail(this.user, this.form, this.emailSignUpOrSignIn);
		};

		this.validateEmail = function(user, form, callback) {
			this.onValidateEmail({user: user, form: form, callback: callback});
		};

		this.$onDestroy = function() {
			$document.off("click", self.closeHandler);
		};

		this.closeHandler = function(e) {
			if ($element !== e.target && !$element[0].contains(e.target)) {
				$timeout(function () { self.onClose();});
			}
		};

		this.fieldChange = function(key) {
			this.userEmailHasChanged = true;

			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};
	}]
});
